import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {MainLayout} from '../../containers/Common';
import InvitationList from './InvitationList';
import InvitationSearch from './InvitationSearch';

const State = () => {
  const [urlSearchParams] = useSearchParams();
  const initialSearchParams = {};
  ['meeting', 'email_status'].forEach((name) => {
    const value = urlSearchParams.get(name);
    if (value) {
      initialSearchParams[name] = name === 'meeting' ? Number(value) : value;
    }
  });
  const [searchParams, setSearchParams] = useState(initialSearchParams);

  const breadCrumbs = [
    {key: 'invitation', name: 'Einladungen'}
  ];

  return <MainLayout breadCrumbs={breadCrumbs}>
    <InvitationSearch searchParams={searchParams} setSearchParams={setSearchParams}/>
    {searchParams.meeting && <InvitationList searchParams={searchParams}/>}
  </MainLayout>;
};

export default State;
